import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';

import BookingHook from '../hooks/BookingHook';
import PackagesHook from '../hooks/PackagesHook';
import AgenciesHook from '../hooks/AgenciesHook';
import AgenciesStatsHook from '../hooks/AgenciesStatsHook';

import moment from "moment";
const DATE_FORMATS = ["YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY","DD/MM/YYYY"];

export default function Dashboard() {
  const { getBookings } = BookingHook();
  const { getPackages } = PackagesHook();
  const { getAgencies } = AgenciesHook();
  const { getAgenciesStats,totalSearches,totalClicks,profileClicks } = AgenciesStatsHook();


  useEffect(() => {
    getAgenciesStats()
    getAgencies()
    getPackages()
    getBookings()
    document.title = "Dashboard"
  }, [])

  const collapsed = useSelector((state) => state.collapsed.collapsed);
  const bookings = useSelector((state) => state.bookings.bookings);
  const agencies = useSelector((state) => state.agencies.agencies);
  const packages = useSelector((state) => state.packages.packages);
  const todayDate = moment().format("YYYY-MM-DD");


  const parseAndFormatDate = (dateString) => {
    if (!dateString) return null;
    // Try parsing with multiple formats. If successful, format to YYYY-MM-DD
    const m = moment(dateString, DATE_FORMATS, true); // `true` for strict parsing
    return m.isValid() ? m.format("YYYY-MM-DD") : null;
  };
  // Pre-process bookings to ensure all relevant dates are in YYYY-MM-DD format
  const processedBookings = bookings.map(booking => {
    // Create a shallow copy of the top-level booking object
    const newBooking = { ...booking };
  
    // --- Process arrival_flight details with deep copying ---
  
      // Process arrival_flight_date
      if (newBooking.return_date) {
        // console.log('newBooking.arrival_flight?.arrival_flight_date (before parse):', newBooking.arrival_flight.arrival_flight_date);
        newBooking.return_date = parseAndFormatDate(newBooking.return_date);
        // console.log('newBooking.arrival_flight?.arrival_flight_date (after parse):', newBooking.arrival_flight.arrival_flight_date);
      }
      // Process take_off_flight_date (if it exists)
      if (newBooking.return_to_date) {
        newBooking.return_to_date = parseAndFormatDate(newBooking.return_to_date);
      }
    
  
    // --- Process departure_flight details with deep copying ---
    if (newBooking.departure_date) {
      // Process departure_flight_date
      if (newBooking.departure_date) {
        newBooking.departure_date = parseAndFormatDate(newBooking.departure_date);
      }
      // Process departure_to_flight_date (if it exists)
      if (newBooking.departure_to_date) {
        newBooking.departure_to_date = parseAndFormatDate(newBooking.departure_to_date);
      }
    }

    return newBooking;
  }).filter(booking => {
    // Optional: Filter out bookings that failed to parse critical dates if necessary
    // For example, if arrival_flight_date is crucial:
    return booking.return_date !== null;
  })
  

     // Filter current bookings
     const currentBookings = processedBookings.filter((booking) =>
      moment(booking.return_date).isAfter(todayDate)
    );
    const totalCurrentBookings=currentBookings.reduce((total, data) => total + (data.totalMembers || 0), 0);

  const totalBookings = processedBookings.reduce((total, data) => total + (data.totalMembers || 0), 0);

  const upcomingBookings = processedBookings.filter((booking) =>
    moment(booking.departure_date).isAfter(todayDate)
  );
  const totalUpcomingBookings = upcomingBookings.reduce((total, data) => total + (data.totalMembers || 0), 0);

  
    const pastBookings = processedBookings.filter((booking) =>
      moment(booking.return_date).isBefore(todayDate)
    )
    const totalPastBookings=pastBookings.reduce((total, data) => total + (data.totalMembers || 0), 0);
  
  return (
    <div className={`${collapsed ? "collapsed mt-5 " : "main mt-5"}`}>
      <div className="container-fluid bg-none my-0 mt-4 dashboard">
        <div className="row px-2 mt-3 pt-4">
        <div className="col-md-12 data_table p-2 pb-3">
            <div className="d-flex justify-content-between searchbar pb-2 pt-1 px-md-2 my-auto">
              <div className="d-flex left my-auto ps-3 ps-md-0">
                <h4 className='my-auto'>Analytics</h4>
              </div>
             
            </div>

            <div className="row px-3 mt-2">
              <div className="col-md-4 my-1 px-1">
                <div className="content ">
                  <div className="d-flex justify-content-between  px-2 pt-3 pb-4">
                    <div className="left my-auto">
                      <h6 className='my-auto'>Package Searches</h6>

                    </div>
                    <div className="right my-auto">
                      <h5 className='my-auto'>{totalSearches}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 my-1 px-1">
                <div className="content">
                  <div className="d-flex justify-content-between px-2 pt-3 pb-4">
                    <div className="left my-auto">
                      <h6 className=' my-auto'>Package Clicks</h6>
                     

                    </div>
                    <div className="right mty-auto">
                      <h5 className='my-auto'>{totalClicks}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 my-1 px-1">
                <div className="content ">
                  <div className="d-flex justify-content-between px-2 pt-3 pb-4">
                    <div className="left my-auto">
                      <h6 className='my-auto'>Conatct Us Clicks</h6>
                      

                    </div>
                    <div className="right my-auto">
                      <h5 className='my-auto'>{profileClicks}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 data_table p-2 pb-3 mt-3">
            <div className="d-flex justify-content-between searchbar pb-2 pt-1 px-md-2 my-auto">
              <div className="d-flex left my-auto ps-3 ps-md-0">
                <h4 className='my-auto'>Agencies: {agencies?agencies.length:'00'}</h4>
              </div>
            </div>
            <div className="row px-3 mt-2">
              <div className="col-md-3 my-1 px-1">
                <div className="content  p-2">
                  <div className="d-flex justify-content-between px-2">
                    <div className="left">
                      <h6>Approved</h6>
                      <span className='up'>
                      <i class="fa-solid fa-person-circle-check"></i>
                        
                      </span>

                    </div>
                    <div className="right mt-auto">
                      <h5 className='mt-auto'>{agencies &&agencies.filter(item => item.isVerified).length}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 my-1 px-1">
                <div className="content  p-2">
                  <div className="d-flex justify-content-between px-2">
                    <div className="left">
                      <h6>Awaiting</h6>
                      <span className='down'>
                      <i class="fa-solid fa-clock-rotate-left"></i>
                      </span>

                    </div>
                    <div className="right mt-auto">
                      <h5 className='mt-auto'>{agencies &&agencies.filter(item => !item.isVerified).length}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 my-1 px-1">
                <div className="content p-2">
                  <div className="d-flex justify-content-between px-2">
                    <div className="left">
                      <h6>Active</h6>
                      <span className='up'>
                      <i class="fa-solid fa-signal"></i>
                      </span>

                    </div>
                    <div className="right mt-auto">
                      <h5 className='mt-auto'>{agencies &&agencies.filter(item => item.isActive).length}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 my-1 px-1">
                <div className="content p-2">
                  <div className="d-flex justify-content-between px-2">
                    <div className="left">
                      <h6>Inactive</h6>
                      <span className='down'>
                      <i class="fa-solid fa-signal"></i>
                      </span>

                    </div>
                    <div className="right mt-auto">
                      <h5 className='mt-auto'>{agencies &&agencies.filter(item => !item.isActive).length}</h5>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

{/* packages */}

            <div className="col-md-12 data_table p-2 pb-3 mt-3">
            <div className="d-flex justify-content-between searchbar pb-2 pt-1 px-md-2 my-auto">
              <div className="d-flex left my-auto ps-3 ps-md-0">
                <h4 className='my-auto'>Packages: {packages?packages.length:'00'}</h4>
              </div>
              
            </div>

            <div className="row px-3 mt-2">
              <div className="col-md-6 my-1 px-1">
                <div className="content  p-2">
                  <div className="d-flex justify-content-between px-2">
                    <div className="left">
                      <h6>Active</h6>
                      <span className='up'>
                      <i class="fa-solid fa-person-circle-check"></i>
                        
                      </span>

                    </div>
                    <div className="right mt-auto">
                      <h5 className='mt-auto'>{packages &&packages.filter(item => item.isActive).length}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 my-1 px-1">
                <div className="content  p-2">
                  <div className="d-flex justify-content-between px-2">
                    <div className="left">
                      <h6>Inactive</h6>
                      <span className='down'>
                      <i class="fa-solid fa-clock-rotate-left"></i>
                      </span>

                    </div>
                    <div className="right mt-auto">
                      <h5 className='mt-auto'>{packages &&packages.filter(item => !item.isActive).length}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bookings */}
          <div className="col-md-12 data_table p-2 pb-3 mt-3 mb-2">
            <div className="d-flex justify-content-between searchbar pb-2 pt-1 px-md-2 my-auto">
              <div className="d-flex left my-auto ps-3 ps-md-0">
                <h4 className='my-auto'>Bookings: {totalBookings?totalBookings:'00'}</h4>
              </div>
            
            </div>

            <div className="row px-3 mt-2">
              <div className="col-md-4 my-1 px-1">
                <div className="content  p-2">
                  <div className="d-flex justify-content-between px-2">
                    <div className="left">
                      <h6>Current</h6>
                      <span className='up'>
                      <i class="fa-solid fa-person-circle-check"></i>
                      </span>
                    </div>
                    <div className="right mt-auto">
                      <h5 className='mt-auto'>{totalCurrentBookings &&totalCurrentBookings}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 my-1 px-1">
                <div className="content  p-2">
                  <div className="d-flex justify-content-between px-2">
                    <div className="left">
                      <h6>Upcoming</h6>
                      <span className='down'>
                      <i class="fa-solid fa-clock-rotate-left"></i>
                      </span>

                    </div>
                    <div className="right mt-auto">
                      <h5 className='mt-auto'>{totalUpcomingBookings &&totalUpcomingBookings}</h5>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 my-1 px-1">
                <div className="content  p-2">
                  <div className="d-flex justify-content-between px-2">
                    <div className="left">
                      <h6>Past</h6>
                      <span className='down'>
                      <i class="fa-solid fa-clock-rotate-left"></i>
                      </span>

                    </div>
                    <div className="right mt-auto">
                      <h5 className='mt-auto'>{totalPastBookings &&totalPastBookings}</h5>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
